import { apiClient } from "@/api/api-client";
import ReactECharts from "echarts-for-react";
import { useEffect, useState } from "react";

const CourtTypeChart = ({ level }: { level: string }) => {
	interface Statistics {
		tooltip: {
			trigger: string;
			axisPointer: {
				type: string;
			};
		};
		legend: {
			right: number;
			top: number;
		};
		grid: {
			left: string;
			right: string;
			bottom: string;
			containLabel: boolean;
		};
		title: {
			text: string;
			top: number;
			left: number;
			textStyle: {
				fontSize: number;
			};
		};
		xAxis: {
			type: string;
			boundaryGap: [number, number];
			minInterval: number;
		};
		yAxis: {
			type?: string;
			data?: any[];
			inverse?: boolean;
		};
		series: {
			name: string;
			type: string;
			data: any[];
			itemStyle: {
				color: string;
			};
		}[];
	}
	const staticOptions = {
		tooltip: {
			trigger: "axis",
			axisPointer: {
				type: "shadow",
			},
		},
		legend: {
			right: 0,
			top: 10,
		},
		grid: {
			left: "3%",
			right: "4%",
			bottom: "3%",
			containLabel: true,
		},
	};
	const [statistics, setStatistics] = useState<Statistics[]>([]);
	const colors = {
		pending: "#f87171",
		withDecision: "#eab308",
		withAppeal: "#3b82f6",
		caseClosed: "#82ca9d",
	};

	const fetchStatistics = async () => {
		const response = await apiClient.get(`/backoffice/court-type-report?level=${level}`);
		if (response && response.data) {
			const temp = [];

			response.data.map((item) => {
				temp.push({
					...staticOptions,
					title: {
						text: "",
						extra: {
							court_type_name: item.court_type_name,
						},
						top: 10,
						left: 0,
						textStyle: {
							fontSize: 14,
						},
					},
					xAxis: {
						type: "value",
						boundaryGap: [0, 0.01],
						minInterval: 1,
						// max: item.total_count,
					},
					yAxis: {
						type: "category",
						inverse: true,
						data: item.region_name,
					},
					series: [
						{
							name: "Pending w/o Decision",
							type: "bar",
							data: item.pending_count,
							itemStyle: {
								color: colors.pending,
							},
						},
						{
							name: "Pending w/ Decision",
							type: "bar",
							data: item.with_decision_count,
							itemStyle: {
								color: colors.withDecision,
							},
						},
						{
							name: "With Appeal",
							type: "bar",
							data: item.with_appeal_count,
							itemStyle: {
								color: colors.withAppeal,
							},
						},
						{
							name: "Case Closed",
							type: "bar",
							data: item.case_closed_count,
							itemStyle: {
								color: colors.caseClosed,
							},
						},
					],
					graphic: [
						{
							type: "text",
							left: 5,
							bottom: 10,
							style: {
								text: "",
								fontSize: 14,
								backgroundColor: "none",
								// height: 34,
							},
							onclick: () => {},
						},
					],
					case_data: item.case_data,
				});
			});

			setStatistics(temp);
		}
	};

	const computeChartHeight = (yAxisCount = 1) => {
		let height = 80;
		height = height + yAxisCount * 40;

		return `${height}px`;
	};

	useEffect(() => {
		fetchStatistics();
	}, []);

	return (
		<div className="grid grid-cols-12 w-full gap-4">
			{statistics &&
				statistics.map((item, index) => (
					<div className="col-span-12" key={index}>
						<div className="flex flex-col w-full gap-4">
							<div className="flex flex-col w-full h-auto rounded-md border border-border/50 overflow-hidden">
								<div className="flex flex-row w-full p-3 border-b border-border/50 items-center">
									<div className="flex flex-col w-6/12 text-base font-semibold text-foreground-dark">{item.title.extra.court_type_name}</div>
								</div>
								<div
									style={{
										width: "100%",
										height: computeChartHeight(item.yAxis.data?.length),
									}}
								>
									<ReactECharts option={item} style={{ height: "100%", width: "100%" }} />
								</div>
							</div>
						</div>
					</div>
				))}
		</div>
	);
};

export default CourtTypeChart;
